import { render, staticRenderFns } from "./FilterItem.vue?vue&type=template&id=47175b44&"
import script from "./FilterItem.ts?vue&type=script&lang=ts&"
export * from "./FilterItem.ts?vue&type=script&lang=ts&"
import style0 from "./FilterItem.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports